// extracted by mini-css-extract-plugin
export default {"header":"DashHeader_header__OMAZt","dashboardTop":"DashHeader_dashboardTop__9HKf8"};